import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthGuard {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const url: string = state.url;
    return this.isLoginValid(url);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(childRoute, state);
  }

  isLoginValid(url: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const currentUser = this.authService.getCurrentUser();
      if (currentUser !== null && currentUser.username !== undefined) {
        const expirationDate = this.authService.getTokenExpirationDate();

        let isValid = true;

        if (expirationDate === null || expirationDate.getTime() <= new Date().getTime()) {
          this.authService.logout();
          isValid = false;
        } else {
          isValid = true;
        }

        this.authService.validateSession().subscribe({
          next: (result) => {
            isValid = result.isValid;
            if (!isValid) {
              this.router.navigate(['/login']); // Navigate to login if session is not valid
            }
            observer.next(isValid);
            observer.complete(); // Emit the final value and complete the Observable
          },
          error: (error) => {
            console.error('Error validating session:', error);
            this.authService.logout(); // Logout user in case of error
            this.router.navigate(['/login']); // Navigate to login in case of error
            observer.next(false);
            observer.complete();
          },
        });
      } else {
        this.router.navigate(['/login']);
        observer.next(false); // Emit false
        observer.complete(); // Complete the Observable
      }
    });
  }
}

// import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
// import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';
// import { AuthenticationService } from '../services/authentication.service';

// /**
//  * Guard service, used to check, for each route if user is authenticated.
// */
// @Injectable()
// export class AuthGuard  {
//   constructor(private authService: AuthenticationService,
//     private router: Router) { }

//   canActivate(route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
//     const url: string = state.url;
//     return this.isLoginValid(url);
//   }

//   canActivateChild(childRoute: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
//     return this.canActivate(childRoute, state);
//   }

//   isLoginValid(url: string): boolean {
//     const currentUser = this.authService.getCurrentUser();
//     if (currentUser !== null && currentUser.username !== undefined) {
//       const expirationDate = this.authService.getTokenExpirationDate();

//       var isValid = true;

//       if ((expirationDate === null || expirationDate.getTime() <= new Date().getTime())) {
//         this.authService.logout();
//         isValid = false;
//       } else {

//         isValid = true;
//       }

//       this.authService.validateSession().subscribe(
//         {
//           next: (result) => {
//             isValid = result.isValid;
//           }
//         }
//       );

//       return isValid;

//     }

//     this.router.navigate(['/login']);
//     return false;
//   }

// }
